import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFlag$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFlag extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'add94b83dbb18b66acf151304bca7a8640485e19', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8f23abaae81b3cf30ccd09aa0c4f882b54b0a369', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ccb385822f6a816ab8681da770f77548d4edb9a5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.11 8 18 3.55a.4.4 0 0 0-.4-.55H5.5a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5V13h11.09a.4.4 0 0 0 .37-.55zm-.17 3.48H6.5v-7H16l-1.44 3.35a.5.5 0 0 0 0 .38z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-flag", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-flag"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-flag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFlag$1);
            }
            break;
    } });
}

const CosmosIconFlag = CosmosIconFlag$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFlag, defineCustomElement };
